// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__KslbU","spin":"Spinner_spin__1Eg6h","container":"Spinner_container__1rbkZ"};